export function getCurrentYearDatesISO() {
  const year = new Date().getFullYear();

  const formatDate = (date) => {
    const offset = date.getTimezoneOffset();
    date = new Date(date.getTime() - offset * 60 * 1000);
    return date.toISOString().split("T")[0];
  };

  const firstDate = formatDate(new Date(year, 0, 1));  // Jan 1
  const lastDate = formatDate(new Date(year, 11, 31)); // Dec 31

  return { firstDate, lastDate };
}

